export const UI_SCHEMA = {
    basic: {
        field_name1: {
            'ui:field': '/schemas/jsf-number'
        },
        field_name2: {
            'ui:field': '/schemas/jsf-float'
        }
    }
};
export const SCHEMA = {
    type: 'object',
    properties: {
        basic: {
            type: 'object',
            title: 'Компонент: NumberJsField',
            required: ['field_name1'],
            properties: {
                field_name1: {
                    title: 'Давление',
                    type: ['string', 'null'],
                    minimum: 0,
                    maximum: 15,
                    readOnly: true,
                    $comment: 'кПа'
                },
                field_name2: {
                    title: 'Давление',
                    type: ['string', 'null'],
                    minimum: 0,
                    maximum: 15,
                    readOnly: true,
                    $comment: 'кПа'
                }
            }
        }
    }
};
export const FORM_DATA = {
    basic: {
        field_name1: '10',
        field_name2: '10.1'
    }
};
//# sourceMappingURL=NumberJsField.example.js.map